import { render, staticRenderFns } from "./yycXieCheDan.vue?vue&type=template&id=63294a42&scoped=true&"
import script from "./yycXieCheDan.vue?vue&type=script&lang=js&"
export * from "./yycXieCheDan.vue?vue&type=script&lang=js&"
import style0 from "./yycXieCheDan.vue?vue&type=style&index=0&id=63294a42&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63294a42",
  null
  
)

export default component.exports